import { getAvailableLanguages } from '../Languages';

/**
 * Default target locales for company article auto-translation — same set historically used
 * for external articles (see TranslationProgressModal / backend defaults).
 */
export const DEFAULT_EXTERNAL_ARTICLE_TRANSLATION_CODES = [
  'de', 'en', 'fr', 'it', 'es', 'pt', 'bg', 'ru', 'ro', 'tr',
];

const UI_ORDER = () => getAvailableLanguages().map((l) => l.code);

export function sortArticleTranslationLangCodes(codes) {
  const order = UI_ORDER();
  const set = new Set(codes);
  return order.filter((c) => set.has(c));
}

/**
 * @param {string[]|null|undefined} selected – from API; nullish → use external-article defaults
 * @returns {string[]} validated codes in UI language list order
 */
export function normalizeArticleTranslationLanguages(selected) {
  const allowed = new Set(getAvailableLanguages().map((l) => l.code));
  const fallback = DEFAULT_EXTERNAL_ARTICLE_TRANSLATION_CODES.filter((c) =>
    allowed.has(c),
  );
  if (selected == null) {
    return sortArticleTranslationLangCodes(fallback);
  }
  const codes = (Array.isArray(selected) ? selected : [])
    .map((c) => String(c).toLowerCase())
    .filter((c) => allowed.has(c));
  const uniq = [...new Set(codes)];
  if (uniq.length === 0) {
    return sortArticleTranslationLangCodes(fallback);
  }
  return sortArticleTranslationLangCodes(uniq);
}

export function getArticleTranslationUiOptions() {
  return getAvailableLanguages();
}
